import React, { useState } from 'react'
import {
	FAQPreviewList,
	FAQPreviewListItem,
	FAQPreviewListItemText,
	FAQPreviewListItemTitle,
	FAQPreviewIcon,
} from './style'
import { Icon } from '../Icon'
import ReactHtmlParser from 'react-html-parser'

const FAQPreview = ({ faqs = [] }) => {
	let previewedFAQItems = faqs.slice(0, 3)
	const [isOpenOne, setIsOpenOne] = useState(false)
	const [isOpenSecond, setIsOpenSecond] = useState(false)
	const [isOpenThird, setIsOpenThird] = useState(false)

	const toggle = (idx) => {
		switch (idx) {
			case 0:
				setIsOpenOne(!isOpenOne)
				break
			case 1:
				setIsOpenSecond(!isOpenSecond)
				break
			case 2:
				setIsOpenThird(!isOpenThird)
				break
			default:
				console.log('FAQ preview undefined item collapse')
				break
		}
	}

	const getStatus = (idx) => {
		switch (idx) {
			case 0:
				return isOpenOne
			case 1:
				return isOpenSecond
			case 2:
				return isOpenThird
			default:
				return false
		}
	}

	return (
		<FAQPreviewList>
			{previewedFAQItems.map((previewedFAQItem, idx) => {
				let isOpen = getStatus(idx)
				return (
					<FAQPreviewListItem
						key={idx}
						onClick={() => {
							toggle(idx)
						}}
					>
						<FAQPreviewIcon>
							<Icon
								component={
									isOpen ? 'minusRadial' : 'plusRadial'
								}
							/>
						</FAQPreviewIcon>
						<FAQPreviewListItemTitle isOpen={isOpen}>
							{previewedFAQItem.title}
						</FAQPreviewListItemTitle>
						<FAQPreviewListItemText isOpen={isOpen}>
							{ReactHtmlParser(previewedFAQItem.text)}
						</FAQPreviewListItemText>
					</FAQPreviewListItem>
				)
			})}
		</FAQPreviewList>
	)
}
export default FAQPreview
